import React from 'react'

export const IsometricFactory: React.FC<{ isDark?: boolean }> = ({ isDark = true }) => {
  return (
    <div className='w-full h-[400px] flex items-center justify-start relative overflow-hidden'>
      <style>{`
        @keyframes svg-conveyor {
          0% {
            transform: translate(0px, 0px);
          }
          100% {
            transform: translate(-28.6px, 15.192px);
          }
        }
        @keyframes disc-conveyor-1 {
          0% { transform: translate(198px, 46.8px); opacity: 0; }
          5% { transform: translate(189.2px, 51.9px); opacity: 1; }
          90% { transform: translate(21.6px, 148.6px); opacity: 1; }
          94% { transform: translate(21.6px, 175px); opacity: 1; }
          95% { transform: translate(21.6px, 175px); opacity: 0; }
          100% { transform: translate(21.6px, 175px); opacity: 0; }
        }
        @keyframes disc-conveyor-2 {
          0% { transform: translate(198px, 46.8px); opacity: 0; }
          5% { transform: translate(189.2px, 51.9px); opacity: 1; }
          90% { transform: translate(21.6px, 148.6px); opacity: 1; }
          94% { transform: translate(21.6px, 180px); opacity: 1; }
          95% { transform: translate(21.6px, 180px); opacity: 0; }
          100% { transform: translate(21.6px, 180px); opacity: 0; }
        }
        @keyframes disc-conveyor-3 {
          0% { transform: translate(198px, 46.8px); opacity: 0; }
          5% { transform: translate(189.2px, 51.9px); opacity: 1; }
          90% { transform: translate(21.6px, 148.6px); opacity: 1; }
          94% { transform: translate(21.6px, 185px); opacity: 1; }
          95% { transform: translate(21.6px, 185px); opacity: 0; }
          100% { transform: translate(21.6px, 185px); opacity: 0; }
        }
        .animate-svg-conveyor { animation: svg-conveyor 1.5s linear infinite; }
        .animate-disc-1 { animation: disc-conveyor-1 11s linear infinite 0s; }
        .animate-disc-2 { animation: disc-conveyor-2 11s linear infinite -3.66s; }
        .animate-disc-3 { animation: disc-conveyor-3 11s linear infinite -7.33s; }

        @keyframes bin-disc-1 {
          0%, 28.3% { opacity: 0; }
          28.4%, 96% { opacity: 1; }
          97%, 100% { opacity: 0; }
        }
        @keyframes bin-disc-2 {
          0%, 61.7% { opacity: 0; }
          61.8%, 96% { opacity: 1; }
          97%, 100% { opacity: 0; }
        }
        @keyframes bin-disc-3 {
          0%, 94.9% { opacity: 0; }
          95%, 96% { opacity: 1; }
          97%, 100% { opacity: 0; }
        }
        .animate-bin-disc-1 { animation: bin-disc-1 11s linear infinite; }
        .animate-bin-disc-2 { animation: bin-disc-2 11s linear infinite; }
        .animate-bin-disc-3 { animation: bin-disc-3 11s linear infinite; }

        @keyframes fire-burn {
          0%, 94% { opacity: 0; transform: scaleY(0.1); }
          95% { opacity: 1; transform: scaleY(0.5); }
          95.5% { opacity: 1; transform: scaleY(1.2); }
          96% { opacity: 1; transform: scaleY(0.8); }
          96.5% { opacity: 1; transform: scaleY(1.3); }
          97% { opacity: 1; transform: scaleY(0.9); }
          97.5% { opacity: 1; transform: scaleY(1.1); }
          98% { opacity: 1; transform: scaleY(0.7); }
          99% { opacity: 0; transform: scaleY(0.1); }
          100% { opacity: 0; }
        }
        .animate-fire { animation: fire-burn 11s linear infinite; transform-origin: 0px 0px; }

        @keyframes light-1 {
          0%, 14%, 32%, 33.3%, 47%, 65.3%, 66.6%, 80%, 98.6%, 100% { opacity: 0; }
          15%, 31%, 48.3%, 64.3%, 81.6%, 97.6% { opacity: 1; }
        }
        @keyframes light-2 {
          0%, 18%, 32%, 33.3%, 51%, 65.3%, 66.6%, 84%, 98.6%, 100% { opacity: 0; }
          19%, 31%, 52.3%, 64.3%, 85.6%, 97.6% { opacity: 1; }
        }
        @keyframes light-3 {
          0%, 22%, 32%, 33.3%, 55%, 65.3%, 66.6%, 88%, 98.6%, 100% { opacity: 0; }
          23%, 31%, 56.3%, 64.3%, 89.6%, 97.6% { opacity: 1; }
        }
        @keyframes light-4 {
          0%, 26%, 32%, 33.3%, 59%, 65.3%, 66.6%, 92%, 98.6%, 100% { opacity: 0; }
          27%, 31%, 60.3%, 64.3%, 93.6%, 97.6% { opacity: 1; }
        }
        .animate-light-1 { animation: light-1 11s linear infinite; }
        .animate-light-2 { animation: light-2 11s linear infinite; }
        .animate-light-3 { animation: light-3 11s linear infinite; }
        .animate-light-4 { animation: light-4 11s linear infinite; }
        @keyframes matrix-scroll {
          0% { transform: translateX(25px); }
          100% { transform: translateX(-35px); }
        }
        .animate-matrix { animation: matrix-scroll 3s linear infinite; }

        @keyframes dissolve {
          0% { transform: translate(0, 0); opacity: 1; }
          100% { transform: translate(4px, -2px); opacity: 0; }
        }
        .animate-dissolve-1 { animation: dissolve 2s infinite linear; }
        .animate-dissolve-2 { animation: dissolve 2s infinite linear 0.7s; }
        .animate-dissolve-3 { animation: dissolve 2s infinite linear 1.4s; }
      `}</style>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='400'
        height='400'
        fill='none'
        viewBox='-20 -70 280 320'
        className='drop-shadow-2xl'
        style={{ filter: isDark ? 'none' : 'invert(1) hue-rotate(180deg)' }}
      >
        <defs>
          <filter id='glow' x='-50%' y='-50%' width='200%' height='200%'>
            <feGaussianBlur stdDeviation='1.5' result='blur' />
            <feMerge>
              <feMergeNode in='blur' />
              <feMergeNode in='SourceGraphic' />
            </feMerge>
          </filter>
          <filter id='text-glow' x='-50%' y='-50%' width='200%' height='200%'>
            <feGaussianBlur stdDeviation='0.6' result='blur' />
            <feMerge>
              <feMergeNode in='blur' />
              <feMergeNode in='SourceGraphic' />
            </feMerge>
          </filter>
          <linearGradient id='light-grad-white' x1='0' y1='0' x2='1' y2='0'>
            <stop offset='0%' stopColor='#ffffff' stopOpacity='0.7' />
            <stop offset='50%' stopColor='#ffffff' stopOpacity='1' />
            <stop offset='100%' stopColor='#ffffff' stopOpacity='0.7' />
          </linearGradient>
          <linearGradient id='light-grad-blue' x1='0' y1='0' x2='1' y2='0'>
            <stop offset='0%' stopColor='#0052FF' stopOpacity='0.7' />
            <stop offset='50%' stopColor='#4D88FF' stopOpacity='1' />
            <stop offset='100%' stopColor='#0052FF' stopOpacity='0.7' />
          </linearGradient>
          <clipPath id='belt-clip'>
            <path d='m236.7 58.08-70.21-10.09c-3.59-0.5-6.49-0.14-9.76 1.62l-143 75.96 94.37 13.46-4.38 26.41 1.18-0.15c1.79-0.25 3.2-1 4.72-2.01l128.1-82.37c7.46-5.23 7.2-18.94-1.02-22.83z' />
          </clipPath>
          <clipPath id='screen-clip'>
            <path d='m143.5 95.07 23.01-11.45 0.22 19.11-23.38 11.45-0.14-18.12c0-0.55-0.15-0.75 0.29-0.99z' />
          </clipPath>
          <path id='belt-line' d='M -200 -28.74 l 600 86.22' stroke='#FFFFFF' strokeMiterlimit='10' strokeWidth='1.08' />
          <linearGradient id='paint0_linear_101_243' x1='69.54' x2='116.9' y1='26.7' y2='107.5' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#F1F9FF' offset='0' />
            <stop stopColor='#D1E8FE' offset='1' />
          </linearGradient>
          <linearGradient id='paint1_linear_101_243' x1='158.8' x2='158.8' y1='50.74' y2='191.3' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#3889F9' offset='0' />
            <stop stopColor='#2A66C6' offset='1' />
          </linearGradient>
          <linearGradient id='paint2_linear_101_243' x1='69.49' x2='69.49' y1='64.78' y2='192.9' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#3889F9' offset='0' />
            <stop stopColor='#4495F1' offset='1' />
          </linearGradient>
          <linearGradient id='paint3_linear_101_243' x1='68.45' x2='68.45' y1='86.21' y2='189.2' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#98C5FD' offset='0' />
            <stop stopColor='#98C5FD' stopOpacity='.25' offset='1' />
          </linearGradient>
          <linearGradient id='paint4_linear_101_243' x1='31.86' x2='31.86' y1='155.1' y2='172.6' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#2A66C6' offset='0' />
            <stop stopColor='#01579B' offset='1' />
          </linearGradient>
          <linearGradient id='paint5_linear_101_243' x1='69.92' x2='69.92' y1='158.6' y2='186.9' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#282862' offset='0' />
            <stop stopColor='#28225F' offset='1' />
          </linearGradient>
          <linearGradient id='paint6_linear_101_243' x1='105.5' x2='105.5' y1='169.2' y2='187.8' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#0193E2' offset='0' />
            <stop stopColor='#00659B' offset='1' />
          </linearGradient>
          <linearGradient id='paint7_linear_101_243' x1='155' x2='155' y1='83.62' y2='114.2' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#B8D0F0' offset='0' />
            <stop stopColor='#86B0DD' offset='1' />
          </linearGradient>
          <linearGradient id='paint8_linear_101_243' x1='142.8' x2='142.8' y1='48.78' y2='61.93' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#3889F9' offset='0' />
            <stop stopColor='#2A66C6' offset='1' />
          </linearGradient>
          <linearGradient id='paint9_linear_101_243' x1='142.7' x2='142.7' y1='10.81' y2='56.79' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#98C5FD' offset='0' />
            <stop stopColor='#98C5FD' stopOpacity='.25' offset='1' />
          </linearGradient>
          <linearGradient id='paint10_linear_101_243' x1='142.5' x2='142.5' y1='31.96' y2='44.7' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#2A66C6' offset='0' />
            <stop stopColor='#2A66C6' offset='1' />
          </linearGradient>
          <linearGradient id='fire-grad' x1='0' y1='1' x2='0' y2='0'>
            <stop offset='0%' stopColor='#FFFFFF' />
            <stop offset='40%' stopColor='#D1E8FE' />
            <stop offset='70%' stopColor='#0052FF' />
            <stop offset='100%' stopColor='#001133' stopOpacity='0' />
          </linearGradient>
          <linearGradient id='paint0_linear_1140_14311' x1='95.48' x2='135.5' y1='83.73' y2='244.2' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#253336' offset='0' />
            <stop stopColor='#253336' offset='1' />
          </linearGradient>
          <linearGradient id='paint1_linear_1140_14311' x1='118.8' x2='139.2' y1='27.82' y2='76.85' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#253336' offset='0' />
            <stop stopColor='#253336' offset='1' />
          </linearGradient>
          <linearGradient id='paint2_linear_1140_14311' x1='123.7' x2='133' y1='6.25' y2='11.36' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#253336' offset='0' />
            <stop stopColor='#253336' offset='1' />
          </linearGradient>
          <linearGradient id='paint3_linear_1140_14311' x1='104' x2='111.9' y1='14.19' y2='28.75' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#253336' offset='0' />
            <stop stopColor='#253336' offset='1' />
          </linearGradient>
          <linearGradient id='paint4_linear_1140_14311' x1='138.7' x2='147.1' y1='14.19' y2='27.02' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#253336' offset='0' />
            <stop stopColor='#253336' offset='1' />
          </linearGradient>
          <linearGradient id='paint5_linear_1140_14311' x1='97.85' x2='99.13' y1='36.57' y2='44.97' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#253336' offset='0' />
            <stop stopColor='#253336' offset='1' />
          </linearGradient>
          <linearGradient id='paint6_linear_1140_14311' x1='147.7' x2='149.1' y1='36.57' y2='44.92' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#253336' offset='0' />
            <stop stopColor='#253336' offset='1' />
          </linearGradient>
          <linearGradient id='paint7_linear_1140_14311' x1='215.6' x2='238.6' y1='128.1' y2='136' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#253336' offset='0' />
            <stop stopColor='#253336' offset='1' />
          </linearGradient>
          <linearGradient id='paint8_linear_1140_14311' x1='28.42' x2='51.16' y1='127.8' y2='133.9' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#253336' offset='0' />
            <stop stopColor='#253336' offset='1' />
          </linearGradient>
          <linearGradient id='paint9_linear_1140_14311' x1='112.3' x2='115.2' y1='228.6' y2='248.4' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#253336' offset='0' />
            <stop stopColor='#253336' offset='1' />
          </linearGradient>
          <g id='custom-disc' transform='scale(0.07, 0.035) translate(-125, -125)'>
            <path d='m156.2 83.73h-62.16c-29.42 0-50.97 24.26-50.97 53.23v33.77c0 28.03 21.2 53.04 50.97 53.04h60.82c29 0 51.34-24.7 51.34-53.04v-33.77c0-28.93-21.31-53.23-50-53.23zm-69.52 88.98c-11.92 0-22.54-10.62-22.36-22.45 0.09-5.82 2.07-9.17 6.36-8.04l35.71 9.32c3.37 0.91 2.37 6.4-1.38 11.98-4.34 6.39-11.62 9.19-18.33 9.19zm75.54 0c-10.23 0-21.44-8.5-22.97-16.69-0.53-2.89 0.69-3.93 2.92-4.48l36.11-9.18c4.6-1.22 6.39 1.45 6.39 7.9 0 11.65-10.44 22.45-22.45 22.45z' fill='url(#paint0_linear_1140_14311)' />
            <path d='m124.4 27.82c-7.73 0-10.17 6.39-10.17 10.64 0 5.17 3.35 8.96 6.66 10.19l-1.71 18.79c-11.2 0.4-15.13 3.58-17.15 10.61h44.88c-2.88-8.02-7.96-9.86-17.63-10.61l-1.62-19.02c4.47-1.66 7.18-5.64 7.18-9.96 0-5.7-4.08-10.64-10.44-10.64z' fill='url(#paint1_linear_1140_14311)' />
            <path d='m124.4 6.25c-2.03 0-2.62 1.41-2.62 2.81v9.45c0 1.67 0.81 2.42 2.25 2.42 1.45 0 2.54-1.02 2.54-2.47v-9.49c0-1.49-0.87-2.72-2.17-2.72z' fill='url(#paint2_linear_1140_14311)' />
            <path d='m103.9 14.91c-1.8-1.52-4.19 0.42-3.2 2.6 0.54 1.23 8.32 8.82 8.32 8.82 1.8 1.13 4.03-0.27 3.81-2.07-0.18-1.4-7.62-8.25-8.93-9.35z' fill='url(#paint3_linear_1140_14311)' />
            <path d='m144.8 14.91-8.21 8.38c-1.4 1.98 0.62 4.39 2.8 3.64 0.97-0.35 8.45-9.02 8.63-9.2 1.35-1.89-0.92-4.61-3.22-2.82z' fill='url(#paint4_linear_1140_14311)' />
            <path d='m105.3 36.57h-11.29c-3.11 0-2.51 5.35 0.09 5.35h11.29c3.16 0 3.33-5.35-0.09-5.35z' fill='url(#paint5_linear_1140_14311)' />
            <path d='m154.8 36.57h-10.97c-3.24 0-3.11 5.35 0.09 5.35h10.62c3.42 0 3.68-5.35 0.26-5.35z' fill='url(#paint6_linear_1140_14311)' />
            <path d='m210.9 128.1v0.22c0.49 2.27 0.4 4.82 0.4 7.71v34.33c0 3.13-0.53 5.93-0.62 8.48 9.44-0.35 14.81-7.99 14.81-13.07v-23.43c0-8.23-6.19-14.24-14.59-14.24z' fill='url(#paint7_linear_1140_14311)' />
            <path d='m37.39 127.8c-8.4 0-14.58 7.42-14.58 14.32v24.14c0 6.89 6.09 12.55 14.58 12.55v-0.85c-0.4-1.8-0.31-4.42-0.31-7.51v-33.9c0-3.22 0.31-6 0.53-8.75h-0.22z' fill='url(#paint8_linear_1140_14311)' />
            <path d='m91.21 228.6v2.09c0 8.1 10.9 13.04 23 13.04h20.02c12.1 0 23.48-5.35 23.48-13.04v-1.79l-66.5-0.3z' fill='url(#paint9_linear_1140_14311)' />
          </g>
        </defs>

        <foreignObject x='-20' y='-60' width='160' height='120'>
          <div className='text-white font-sans text-sm leading-snug opacity-80'>
            All agents look and behave like they were made in the same factory somewhere in California. That's because they are.
          </div>
        </foreignObject>

        <path d='m239.8 128.7c0 2.26-4.87 3.67-4.87 3.67l-112.2 65.9c-2.5 1.51-5.47 1.84-8.4 1.28l-89.42-14.12c-2.71-0.48-3.65-3.86-1.39-5.12l34.81-20.51 51.93 6.28 68.75-46.98 55.11 6.66s5.68 0.68 5.68 2.94z' fill='#000000' opacity='.18' />
        <path d='m239.5 128.6c0.11 2.77-4.18 3.9-8.57 3.9-4.21 0-6.99-1.49-7.04-3.82-0.06-2.5 3.38-3.65 7.5-3.68 4.34-0.04 8 1.23 8.11 3.6z' fill='#000000' />
        <path d='m237.2 127.8c0.08 2.11-3.33 2.96-6.35 2.9-3.25-0.07-5.48-1.16-5.48-2.9 0-1.61 2.68-2.74 5.88-2.71 3.25 0.03 5.87 1.16 5.95 2.71z' fill='#FFFFFF' stroke='#000000' strokeMiterlimit='10' strokeWidth='1.08' />
        <path d='m233.8 81.94v46.05h-4.8v-43.16l4.8-2.89z' fill='#FFFFFF' stroke='#000000' strokeMiterlimit='10' strokeWidth='1.08' />
        <path d='m26.91 184.8c0.11 2.77-3.49 3.62-7.49 3.62-3.84 0-7.35-1.16-7.41-3.49-0.07-2.5 2.6-3.35 6.44-3.38 4.04-0.05 8.36 0.88 8.46 3.25z' fill='#000000' />
        <path d='m25.5 184.3c0.08 2.11-2.99 2.78-5.81 2.73-3.03-0.06-5.1-1.1-5.1-2.73 0-1.53 2.43-2.57 5.42-2.54 3.03 0.03 5.42 1.07 5.49 2.54z' fill='#FFFFFF' stroke='#000000' strokeMiterlimit='10' strokeWidth='1.08' />
        <path d='m21.58 148.8v35.21l-5.82-0.61v-34.34l5.82-0.26z' fill='#FFFFFF' stroke='#000000' strokeMiterlimit='10' strokeWidth='1.08' />
        <path d='m120.6 198.2c0.1 2.77-3.89 3.62-7.89 3.62-3.84 0-6.79-1.16-6.85-3.49-0.07-2.5 2.6-3.35 6.44-3.38 4.04-0.05 8.2 0.88 8.3 3.25z' fill='#000000' />
        <path d='m119.4 198.2c0.08 2.11-3.36 2.51-6.18 2.45-3.03-0.06-5.3-0.72-5.3-2.45 0-1.53 2.23-2.86 5.22-2.83 3.23 0.04 6.19 1.35 6.26 2.83z' fill='#FFFFFF' stroke='#000000' strokeMiterlimit='10' strokeWidth='1.08' />
        <path d='m116 158v39.43l-6.44-0.3v-36.1l6.44-3.03z' fill='#FFFFFF' stroke='#000000' strokeMiterlimit='10' strokeWidth='1.08' />
        <path d='m236.7 58.08-70.21-10.09c-3.59-0.5-6.49-0.14-9.76 1.62l-143 75.96 94.37 13.46-4.38 26.41 1.18-0.15c1.79-0.25 3.2-1 4.72-2.01l128.1-82.37c7.46-5.23 7.2-18.94-1.02-22.83z' fill='#0052FF' stroke='#FFFFFF' strokeMiterlimit='10' strokeWidth='1.08' />

        <g clipPath='url(#belt-clip)'>
          <g className='animate-svg-conveyor'>
            {Array.from({ length: 25 }).map((_, i) => {
              const index = i - 5
              const x = 166.49 + index * -28.6
              const y = 47.99 + index * 15.192
              return <use key={i} href='#belt-line' x={x} y={y} />
            })}
          </g>
        </g>

        <g transform='translate(165, -36) scale(0.5)'>
          <path d='m10.39 69.1-0.2 95.95c-0.01 3.08 1.44 5.16 3.63 5.59l112 22.17c3.07 0.62 4.69-0.56 6.95-1.83l53.96-30.85c2.44-1.39 2.86-3.41 2.86-5.41v-99.61c0-3.4-1.76-5.23-4.66-5.57l-33.72-4.42-0.23-34.42c0-2.94-4.77-4.45-8.28-4.45h-0.65c-4.28 0-8.17 1.64-8.17 4.45l0.12 32.41-59.86-7.68c-2-0.21-3.06 0.14-4.15 0.66l-55.7 27.5c-2.49 1.2-3.88 2.95-3.88 5.51z' fill='#0052FF' stroke={isDark ? '#000' : '#fff'} strokeMiterlimit='10' strokeWidth='2.2' />
          <path d='m128.7 82.02 0.32 109c0.88-0.48 1.8-1.12 3-1.79l53.96-29.61c2.44-1.4 3.01-3.42 3.01-5.86v-98.64c0-2.02-0.59-3.45-1.72-4.37l-58.57 31.28z' fill='#0052FF' stroke={isDark ? '#000' : '#fff'} strokeMiterlimit='10' strokeWidth='2.2' />
          <path d='m127.5 82.41-115.1-17.63c-1.08 1.18-1.99 2.4-1.99 4.32l-0.14 95.17c-0.01 3.08 1.17 5.44 3.36 5.87l112 22.64c1.84 0.33 3.07-0.86 3.07-3.93l-0.14-105.2c0-0.73-0.3-1.1-1.03-1.21z' fill='#0052FF' stroke={isDark ? '#000' : '#fff'} strokeMiterlimit='10' strokeWidth='2.2' />
          <path d='M 13.6 170.1 L 125.8 192.8' stroke='#0052FF' strokeWidth='3.5' filter='url(#glow)' />
          <path d='m112 98.39-85.83-12.11c-1.72-0.26-2.93 0.68-2.93 2.64v82.26l90.52 18.01v-87.54c0-1.74-0.43-3.03-1.76-3.26z' fill='url(#paint3_linear_101_243)' />
          <path d='m110.1 103.6-81.58-11.92c-0.44-0.07-0.84 0.36-0.84 0.99v78.95l82.26 17.25v-84.19c0-0.57-0.34-1.01-0.84-1.08z' fill={isDark ? '#000' : '#fff'} />
          <path d='m28.87 93.11 8.25 1.28v60.03l-8.25-1.37v-59.94z' fill={isDark ? '#29364D' : '#B2BFD6'} />
          <path d='m38.72 94.66 10.5 1.69v59.74l-10.5-1.91v-59.52z' fill={isDark ? '#29364D' : '#B2BFD6'} />
          <path d='m50.32 96.43 11.96 1.9v60.44l-11.96-2.21v-60.13z' fill={isDark ? '#29364D' : '#B2BFD6'} />
          <path d='m63.38 98.41 11.96 1.9v60.78l-11.96-2.48v-60.2z' fill={isDark ? '#29364D' : '#B2BFD6'} />
          <path d='m76.44 100.2 11.96 1.75v62.35l-11.96-2.6v-61.5z' fill={isDark ? '#29364D' : '#B2BFD6'} />
          <path d='m89.5 102.1 11.96 1.75v63.05l-11.96-2.29v-62.51z' fill={isDark ? '#29364D' : '#B2BFD6'} />
          <path d='m102.2 103.9 6.33 0.83v63.16l-6.33-0.99v-63z' fill={isDark ? '#29364D' : '#B2BFD6'} />
          <path d='m28.87 155.1 5.97 0.99v16.54l-5.97-1.19v-16.34z' fill='url(#paint4_linear_101_243)' />
          <path d='m36.74 156.2 1.75 0.4v9.08l-2.07 1.37 0.32-10.85z' fill={isDark ? '#29364D' : '#B2BFD6'} />
          <path d='m38.96 166 13.89-7.43 47.93 9.63 1.23 18.62-64.24-13.05 1.19-2.38v-5.39z' fill='url(#paint5_linear_101_243)' stroke={isDark ? '#000' : '#fff'} strokeMiterlimit='10' strokeWidth='1.1' />
          <path d='m102.6 169.2 5.98 0.83v17.79l-5.36-1.37-0.62-17.25z' fill='url(#paint6_linear_101_243)' stroke={isDark ? '#000' : '#fff'} strokeMiterlimit='10' strokeWidth='1.1' />
          <path d='m143.5 95.07 23.01-11.45 0.22 19.11-23.38 11.45-0.14-18.12c0-0.55-0.15-0.75 0.29-0.99z' fill={isDark ? '#000000' : '#ffffff'} stroke={isDark ? '#000' : '#fff'} strokeMiterlimit='10' strokeWidth='2' />
          <g clipPath='url(#screen-clip)'>
            <g transform='translate(144, 104) skewY(-26.5)'>
              <text className='animate-matrix' x='0' y='0' fill={isDark ? '#FFFFFF' : '#000000'} fontFamily="'Courier New', Courier, monospace" fontSize='8' fontWeight='bold' letterSpacing='1'>
                slop
              </text>
            </g>
          </g>
          <path d='m145.8 125.1c2.33-0.31 2.87-3.7 2.38-5.57-0.5-1.88-2.43-2.42-3.67-1.32-1.93 1.75-1.81 3.97-1.19 5.64 0.48 1.3 1.46 1.4 2.48 1.25z' fill='#A2D5FF' stroke={isDark ? '#000' : '#fff'} strokeMiterlimit='10' strokeWidth='1.6' />
          <path d='m154.5 120.1c2.33-0.31 2.87-3.7 2.38-5.57-0.5-1.87-2.43-2.42-3.67-1.32-1.93 1.75-1.81 3.98-1.19 5.64 0.48 1.3 1.46 1.4 2.48 1.25z' fill='#A2D5FF' stroke={isDark ? '#000' : '#fff'} strokeMiterlimit='10' strokeWidth='1.6' />
          <path d='m164.9 115.1c2.33-0.31 2.87-3.7 2.38-5.57-0.49-1.88-2.43-2.43-3.67-1.32-1.93 1.75-1.81 3.97-1.19 5.64 0.48 1.3 1.46 1.4 2.48 1.25z' fill='#A2D5FF' stroke={isDark ? '#000' : '#fff'} strokeMiterlimit='10' strokeWidth='1.6' />
          <path d='m130.7 55.57c-0.09-5.21 7.07-6.76 12.4-6.78 6.01-0.02 12.04 1.45 11.87 6.82-0.13 4.35-5.07 6.11-12.06 6.29-5.91 0.16-12.13-1.83-12.21-6.33z' fill='url(#paint8_linear_101_243)' stroke={isDark ? '#000' : '#fff'} strokeMiterlimit='10' strokeWidth='1.6' />
          <path d='m134.4 10.88 0.33 42.21c0 2.3 4.48 3.72 8.35 3.69 4.45-0.03 7.85-1.45 7.85-3.62l0.28-42.35-16.81 0.07z' fill='url(#paint9_linear_101_243)' stroke={isDark ? '#000' : '#fff'} strokeMiterlimit='10' strokeWidth='1.6' />
          <path d='m134.4 10.71c0-2.44 4.52-3.57 8.38-3.57h0.66c4.18 0 7.74 1.64 7.74 3.57v0.31c0 2.29-4.09 3.69-8.27 3.69h-0.51c-4.02 0-8-1.4-8-3.76v-0.24z' fill='#9BC2E5' stroke={isDark ? '#000' : '#fff'} strokeMiterlimit='10' strokeWidth='1.6' />
          <path d='m134.4 20.84c1.23 1.37 3.9 2.47 8.08 2.32 3.92-0.15 6.82-0.8 8.33-2.32l-0.14 10.43c-1.52 1.37-4.57 2.2-8.07 2.2-3.65 0-6.42-0.99-8.03-2.36l-0.17-10.27z' fill='#F1F9FF' stroke={isDark ? '#000' : '#fff'} strokeMiterlimit='10' strokeWidth='.8' />
          <path d='m134.5 32.29c1.23 1.37 3.81 2.23 7.99 2.15 3.92-0.08 6.53-0.97 8.05-2.23l-0.23 10.27c-1.52 1.37-4.07 2.28-7.56 2.2-3.65-0.07-6.31-0.91-7.92-2.28l-0.33-10.11z' fill='url(#paint10_linear_101_243)' stroke={isDark ? '#000' : '#fff'} strokeMiterlimit='10' strokeWidth='.8' />
          <path className='animate-light-1' transform='translate(0, -9)' d='m134.4 20.84c1.23 1.37 3.9 2.47 8.08 2.32 3.92-0.15 6.82-0.8 8.33-2.32l-0.14 10.43c-1.52 1.37-4.57 2.2-8.07 2.2-3.65 0-6.42-0.99-8.03-2.36l-0.17-10.27z' fill='url(#light-grad-white)' filter='url(#glow)' />
          <path className='animate-light-2' transform='translate(0, 1)' d='m134.4 20.84c1.23 1.37 3.9 2.47 8.08 2.32 3.92-0.15 6.82-0.8 8.33-2.32l-0.14 10.43c-1.52 1.37-4.57 2.2-8.07 2.2-3.65 0-6.42-0.99-8.03-2.36l-0.17-10.27z' fill='url(#light-grad-blue)' filter='url(#glow)' />
          <path className='animate-light-3' transform='translate(0, 11)' d='m134.4 20.84c1.23 1.37 3.9 2.47 8.08 2.32 3.92-0.15 6.82-0.8 8.33-2.32l-0.14 10.43c-1.52 1.37-4.57 2.2-8.07 2.2-3.65 0-6.42-0.99-8.03-2.36l-0.17-10.27z' fill='url(#light-grad-white)' filter='url(#glow)' />
          <path className='animate-light-4' transform='translate(0, 21)' d='m134.4 20.84c1.23 1.37 3.9 2.47 8.08 2.32 3.92-0.15 6.82-0.8 8.33-2.32l-0.14 10.43c-1.52 1.37-4.57 2.2-8.07 2.2-3.65 0-6.42-0.99-8.03-2.36l-0.17-10.27z' fill='url(#light-grad-blue)' filter='url(#glow)' />
        </g>

        <path d='m 108.1 139.03 l -94.37 -13.46 c -6.61 2.21 -9.86 13.46 -5.8 20.37 c 2.29 4.03 5.8 4.35 9.2 4.93 l 85.22 14.44 l 1.37 0.13 c -6.69 -3.47 -5.94 -18.33 4.38 -26.41 z' fill='#000000' stroke='#FFFFFF' strokeMiterlimit='10' strokeWidth='1.08' />
        <path d='m238.4 60.24-132.8 81.97c-7.7 4.97-8.59 20.65-2.1 23.1 2.37 0.91 6.29-1.84 9.41-3.94l125.1-81.5c7.26-5 7.19-16.95 1.8-20.36-0.82-0.52-0.82 0.21-1.35 0.73z' fill='#000000' stroke='#FFFFFF' strokeMiterlimit='10' strokeWidth='1.08' />
        <path d='m231.1 119.1v0.32' stroke='#FFFFFF' strokeMiterlimit='10' strokeWidth='1.08' />
        <path d='m111.6 162.5v27.38' stroke='#FFFFFF' strokeMiterlimit='10' strokeWidth='1.08' />
        <path d='m17.51 175v0.39' stroke='#FFFFFF' strokeMiterlimit='10' strokeWidth='1.08' />

        <g>
          <path d='M -8.4 160 L 21.6 145 L 21.6 185 L -8.4 200 Z' fill='#0f172a' />
          <path d='M 21.6 145 L 51.6 160 L 51.6 200 L 21.6 185 Z' fill='#1e293b' />
          <path d='M -8.4 200 L 21.6 215 L 51.6 200 L 21.6 185 Z' fill='#020617' />
        </g>

        <g className='animate-bin-disc-1'>
          <path d='M 9.6 185 L 9.6 188 A 12 6 0 0 0 33.6 188 L 33.6 185 Z' fill='#FFFFFF' stroke='#000000' strokeWidth='1.08' strokeLinejoin='round' />
          <ellipse cx='21.6' cy='185' rx='12' ry='6' fill='#FFFFFF' stroke='#000000' strokeWidth='1.08' />
          <use href='#custom-disc' x='21.6' y='185' />
        </g>
        <g className='animate-bin-disc-2'>
          <path d='M 9.6 180 L 9.6 183 A 12 6 0 0 0 33.6 183 L 33.6 180 Z' fill='#FFFFFF' stroke='#000000' strokeWidth='1.08' strokeLinejoin='round' />
          <ellipse cx='21.6' cy='180' rx='12' ry='6' fill='#FFFFFF' stroke='#000000' strokeWidth='1.08' />
          <use href='#custom-disc' x='21.6' y='180' />
        </g>
        <g className='animate-bin-disc-3'>
          <path d='M 9.6 175 L 9.6 178 A 12 6 0 0 0 33.6 178 L 33.6 175 Z' fill='#FFFFFF' stroke='#000000' strokeWidth='1.08' strokeLinejoin='round' />
          <ellipse cx='21.6' cy='175' rx='12' ry='6' fill='#FFFFFF' stroke='#000000' strokeWidth='1.08' />
          <use href='#custom-disc' x='21.6' y='175' />
        </g>

        <g className='animate-disc-1'>
          <path d='M -12 0 L -12 3 A 12 6 0 0 0 12 3 L 12 0 Z' fill='#FFFFFF' stroke='#000000' strokeWidth='1.08' strokeLinejoin='round' />
          <ellipse cx='0' cy='0' rx='12' ry='6' fill='#FFFFFF' stroke='#000000' strokeWidth='1.08' />
          <use href='#custom-disc' x='0' y='0' />
        </g>
        <g className='animate-disc-2'>
          <path d='M -12 0 L -12 3 A 12 6 0 0 0 12 3 L 12 0 Z' fill='#FFFFFF' stroke='#000000' strokeWidth='1.08' strokeLinejoin='round' />
          <ellipse cx='0' cy='0' rx='12' ry='6' fill='#FFFFFF' stroke='#000000' strokeWidth='1.08' />
          <use href='#custom-disc' x='0' y='0' />
        </g>
        <g className='animate-disc-3'>
          <path d='M -12 0 L -12 3 A 12 6 0 0 0 12 3 L 12 0 Z' fill='#FFFFFF' stroke='#000000' strokeWidth='1.08' strokeLinejoin='round' />
          <ellipse cx='0' cy='0' rx='12' ry='6' fill='#FFFFFF' stroke='#000000' strokeWidth='1.08' />
          <use href='#custom-disc' x='0' y='0' />
        </g>

        <g transform='translate(21.6, 185)'>
          <g className='animate-fire'>
            <path d='M -10 0 L -12 -20 L 0 -80 L 12 -20 L 10 0 Z' fill='url(#fire-grad)' filter='url(#glow)' />
            <path d='M -5 0 L -6 -15 L 0 -60 L 6 -15 L 5 0 Z' fill='#FFFFFF' filter='url(#glow)' />
            <polygon points='-6,-10 0,-15 6,-10 0,-5' fill='#FFFFFF' opacity='0.9' />
            <polygon points='-5,-25 0,-30 5,-25 0,-20' fill='#FFFFFF' opacity='0.7' />
            <polygon points='-4,-40 0,-45 4,-40 0,-35' fill='#FFFFFF' opacity='0.5' />
            <polygon points='-3,-55 0,-60 3,-55 0,-50' fill='#FFFFFF' opacity='0.3' />
          </g>
        </g>

        <g>
          <path d='M -8.4 160 L 21.6 175 L 21.6 215 L -8.4 200 Z' fill='#0f172a' stroke='#334155' strokeWidth='1' strokeLinejoin='round' />
          <path d='M 21.6 175 L 51.6 160 L 51.6 200 L 21.6 215 Z' fill='#1e293b' stroke='#334155' strokeWidth='1' strokeLinejoin='round' />
          <path d='M 25.6 175 L 47.6 164 L 47.6 184 L 25.6 195 Z' fill='#0052FF' fillOpacity='0.2' stroke='#0052FF' strokeWidth='1.5' filter='url(#glow)' />
          <g transform='translate(36.6, 179.5) skewY(-26.5)' filter='url(#text-glow)'>
            <path d='M -3 -5 L 1 -5 L 3 -3 L 3 5 L -3 5 Z' fill='none' stroke='#FFFFFF' strokeWidth='0.8' strokeLinejoin='round' />
            <path d='M 1 -5 L 1 -3 L 3 -3' fill='none' stroke='#FFFFFF' strokeWidth='0.8' strokeLinejoin='round' />
            <path d='M -1 -1 L 1.5 -1 M -1 1.5 L 0.5 1.5 M -1 4 L 1.5 4' fill='none' stroke='#FFFFFF' strokeWidth='0.6' strokeLinecap='round' />
            <path className='animate-dissolve-1' d='M 4 -3.5 h 0.8 v 0.8 h -0.8 z M 5 3.5 h 0.8 v 0.8 h -0.8 z' fill='#FFFFFF' />
            <path className='animate-dissolve-2' d='M 5.5 -1 h 0.8 v 0.8 h -0.8 z M 7 0.5 h 0.8 v 0.8 h -0.8 z' fill='#FFFFFF' />
            <path className='animate-dissolve-3' d='M 3.5 1.5 h 0.8 v 0.8 h -0.8 z' fill='#FFFFFF' />
          </g>
          <path d='M -4.4 164 L 17.6 175 L 17.6 195 L -4.4 184 Z' fill='#0052FF' fillOpacity='0.2' stroke='#0052FF' strokeWidth='1.5' filter='url(#glow)' />
          <path d='M -8.4 160 L 21.6 175 L 51.6 160' fill='none' stroke='#0052FF' strokeWidth='2.5' filter='url(#glow)' />
        </g>
      </svg>
    </div>
  )
}
